import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Action, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';

function* fetchERPJobImportLogsOperations({ erpJobImportLogsOperationsParams }) {
  try {
    yield put(Action.setERPJobImportLogsOperationsLoaderStatus({ erpJobImportLogsOperationsLoaderStatus: true }));
    const { data } = yield call(api.get, {
      route: 'ERPJobLogsMongo/getERPlogs',
      params: erpJobImportLogsOperationsParams,
    });
    const erpJobImportLogsOperationsData = data;
    yield put(Action.setERPJobImportLogsOperations({ erpJobImportLogsOperationsData }));
    yield put(Action.setERPJobImportLogsOperationsLoaderStatus({ erpJobImportLogsOperationsLoaderStatus: false }));
  } catch (err) {
    yield put(Action.setERPJobImportLogsOperationsLoaderStatus({ erpJobImportLogsOperationsLoaderStatus: false }));
    notification('err', err, '');
    console.warn(err);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_ERP_JOB_IMPORT_LOGS_OPERATION, fetchERPJobImportLogsOperations)]);
}
